export default "__VITE_ASSET__CVQIF$V0__"